module.exports = __webpack_public_path__ + "img/17deviceNew.fc79534b.png";